import { setupWorker } from 'msw';

import { handlers } from './handlers';
import { isMockSeedEnabled, seedHandlers } from './seedHandlers';

// In seed/mock mode the seed handlers intercept the real API endpoints to serve
// a populated board. Otherwise only the legacy `/api/mock/*` handlers are
// registered and real requests pass through to the backend.
export const worker = setupWorker(
  ...(isMockSeedEnabled ? seedHandlers : []),
  ...handlers,
);
